/**
 * Typing Indicator Component
 * Shows animated dots when someone is typing
 */

import React from 'react';

interface TypingIndicatorProps {
  userRole: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ userRole }) => {
  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'vendor':
        return 'Vendor';
      case 'rider':
        return 'Rider';
      case 'ops':
        return 'Support';
      default:
        return 'Someone';
    }
  };

  return (
    <div className="flex items-center gap-2 mb-4">
      <div className="bg-gray-100 rounded-lg px-4 py-2">
        <div className="flex items-center gap-1">
          <span className="text-xs text-gray-600 mr-2">{getRoleLabel(userRole)} is typing</span>
          <div className="flex gap-1">
            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

